// src/App.js
import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Advantages from './components/Advantages';
import Footer from './components/Footer';
import Layout from '../../components/layout';


function ConnectPlus() {
  return (
    <Layout>
      <div className="min-h-screen bg-gray-50">
        {/* <Navbar /> */}
        <Hero />
        <Features />
        <Advantages />
        {/* <Footer /> */}
      </div>
    </Layout>
  );
}

export default ConnectPlus;